import { useSelector } from '/druid/internal/WebChatReduxContext';
import Notification from './druid/types/Notification';

export default function useNotifications(): [Notification[]] {
  return [useSelector(({ notifications }) => notifications)];
}
